<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          styleClass="w-[50vw] max-w-full lg:w-[33.33vw]">
  <ng-template #header>
    <div class="flex-flex-col w-full gap-1">
      <label class="text-left font-bold">{{ isNew ? ( 'newOrg' | translate ) : ( 'editOrg' | translate ) }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="organizationId" class="text-left font-semibold">ID</label>
      <input pInputText id="organizationId" class="orgdept-input col-span-2" [disabled]="true" [(ngModel)]="organization.organizationId" />

      <label for="name" class="text-left font-semibold">{{ 'name' | translate }}</label>
      <input pInputText id="name" class="orgdept-input col-span-2" [disabled]="!isNew" [(ngModel)]="organization.name" />
    </div>

    <p-tabs [(value)]="tabsId">
      <p-tablist>
        <p-tab value="0">{{ 'departments' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <p-table [value]="departments"
                   [scrollable]="true" scrollHeight="flex"
                   dataKey="id"
                   styleClass="p-datatable-striped">
            <ng-template #header>
              <tr>
                <th style="width: 4rem"></th>
                <th style="width: 4rem">ID</th>
                <th style="min-width:15rem">{{ 'name' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-dept>
              <tr>
                <td>
                  <!--<p-tableCheckbox [value]="dept" />-->
                </td>
                <td>{{dept.departmentId}}</td>
                <td>{{dept.name}}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.aria.close' | translate"
              severity="secondary"
              variant="outlined"
              (click)="onClose()" />
    <p-button [label]="'save' | translate"
              (click)="onSave()" />
  </ng-template>
</p-dialog>
